import { FunctionComponent } from "react";
import { Box, Link, useTheme } from "@mui/material";
import { Dashboard } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import { dashboard2ManageColleaguesLinkSx } from "../../Dashboard2/dashboard2-status.styles";

type GoToManagementLinkProps = {
  "data-testid"?: string;
};

/**
 * Tenant/company-admin shortcut to `/management`.
 */
export const GoToManagementLink: FunctionComponent<GoToManagementLinkProps> = ({
  "data-testid": testId = "go-to-management-link"
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { isTenantAdmin, isCompanyAdmin } = useSelector(
    (state: RootState) => state.login.userRoles
  );
  const canOpenManagement = isTenantAdmin || isCompanyAdmin;

  if (!canOpenManagement) {
    return null;
  }

  const label = t("_dashboard2_goToManagement");

  return (
    <Link
      component={RouterLink}
      to="/management"
      underline="hover"
      sx={{
        ...dashboard2ManageColleaguesLinkSx(theme),
        flexShrink: 0
      }}
      data-testid={testId}
      aria-label={label}
    >
      <Dashboard aria-hidden />
      <Box component="span" sx={{ lineHeight: 1 }}>
        {label}
      </Box>
    </Link>
  );
};
